import {imManager} from '@/common-pages/im/im.state';
import {getRechargeCustomers} from '@/services/global.service';
import {goTo} from '@/utils';
import {track} from '@/utils/track';
import {trackEvent} from '@/utils/track-event';
import type {i18n as I18nApi} from 'i18next';
import {progressiveToastFail} from '@fe-progressive/package-progressive/progressive-toast';
import type {
  RechargeAdapter,
  RechargeTrackPayload,
} from '@fe-progressive/package-progressive/recharge';

function pickImCustomer(
  customers: {imUserId: string; imUserStatus?: string}[],
  status?: string,
): string {
  if (status) {
    const list = customers.filter(c => c.imUserStatus === status);
    return list.length
      ? list[Math.floor(Math.random() * list.length)].imUserId
      : pickImCustomer(customers);
  }
  return customers[Math.floor(Math.random() * customers.length)].imUserId;
}

export type RechargeProgressiveAdapterOptions = {
  i18n: I18nApi;
  setLoading: (v: boolean) => void;
};

export function createRechargeProgressiveAdapter(
  opts: RechargeProgressiveAdapterOptions,
): RechargeAdapter {
  const {i18n, setLoading} = opts;

  return {
    onTrack(payload: RechargeTrackPayload) {
      track(payload.event, payload.extra);
      if (payload.event === 'rechargeClick') {
        const amount = payload.amount ?? 0;
        trackEvent('rechargeClick', {amount});
      }
    },
    onRequireLogin: ({backPage}) => {
      goTo('Login', {backPage: backPage ?? 'Home'});
    },
    onRewardTrigger: async () => {},
    onImRecharge: async ({amount, payTag: _payTag}) => {
      try {
        const customers = await getRechargeCustomers();
        const rechargeCustomers = customers.filter(c => c.imCustomer === '1');
        if (rechargeCustomers.length <= 0) {
          setLoading(false);
          progressiveToastFail(
            i18n.t('recharge-page.tip.no-recharge-customer'),
          );
          return;
        }
        imManager.setVisibleState(true, {
          amount,
          customerId: pickImCustomer(rechargeCustomers, '1'),
        });
      } catch {
        setLoading(false);
      }
    },
  };
}
